export default class LanguageService {

  translateLanguages(languages) {
    return languages.map(language => ({
      ...language,
      text: this.state.translations[language.value.toLowerCase()] || language.text
    }));
  }

  translateLikelihoodConversionToView(){
    const { first_likelihood, second_likelihood, third_likelihood, fourth_likelihood, fifth_likelihood, not_applicable } = this.state.translations
    return {
      '1' : first_likelihood.trim(),
      '2' : second_likelihood.trim(),
      '3' : third_likelihood.trim(),
      '4' : fourth_likelihood.trim(),
      '5' : fifth_likelihood.trim(),
      'N/A' : not_applicable.trim()
    }
  }

  translateRiskRatingDict(){
    const { first_likelihood, second_likelihood, third_likelihood, fourth_likelihood, fifth_likelihood,
            low, medium, high, extreme, not_applicable, na_abbre} = this.state.translations
    var dict = {}
    dict[first_likelihood] = {
      1 : { class: 'rating-1-1', label: low },
      2 : { class: 'rating-1-2', label: low },
      4 : { class: 'rating-1-3', label: low },
      6 : { class: 'rating-1-4', label: medium },
      15: { class: 'rating-1-5', label: high }
    }
    dict[second_likelihood] = {
      3 : { class: 'rating-2-1', label: low },
      5 : { class: 'rating-2-2', label: low },
      8 : { class: 'rating-2-3', label: medium },
      12 : { class: 'rating-2-4', label: medium },
      18: { class: 'rating-2-5', label: high }
    }
    dict[third_likelihood] = {
      6 : { class: 'rating-3-1', label: low },
      9 : { class: 'rating-3-2', label: medium },
      13 : { class: 'rating-3-3', label: medium },
      17 : { class: 'rating-3-4', label: high },
      25: { class: 'rating-3-5', label: extreme }
    }
    dict[fourth_likelihood] = {
      10 : { class: 'rating-4-1', label: low },
      14 : { class: 'rating-4-2', label: medium },
      18 : { class: 'rating-4-3', label: high },
      25 : { class: 'rating-4-4', label: extreme },
      25: { class: 'rating-4-5', label: extreme }
    }
    dict[fifth_likelihood] = {
      16 : { class: 'rating-5-1', label: medium },
      19 : { class: 'rating-5-2', label: high },
      25 : { class: 'rating-5-3', label: extreme },
      25 : { class: 'rating-5-4', label: extreme },
      25: { class: 'rating-5-5', label: extreme }
    }
    dict[not_applicable] = {
      0 : { class: '', label: na_abbre }
    }
    return dict
  }

  translateLikelihoodOptions(){
    const { first_likelihood, second_likelihood, third_likelihood, fourth_likelihood, fifth_likelihood, not_applicable } = this.state.translations
    return [
      {
        key: '1: Unlikely in 100 years',
        value: '1: Unlikely in 100 years',
        text: first_likelihood
      },
      {
        key: '2: Once in 10 to 100 years',
        value: '2: Once in 10 to 100 years',
        text: second_likelihood
      },
      {
        key: '3: Once in 1 to 10 years',
        value: '3: Once in 1 to 10 years',
        text: third_likelihood
      },
      {
        key: '4: Once a year',
        value: '4: Once a year',
        text: fourth_likelihood
      },
      {
        key: '5: Several times a year',
        value: '5: Several times a year',
        text: fifth_likelihood
      },
      {
        key: '(N/A) Not Applicable',
        value: '(N/A) Not Applicable',
        text: not_applicable
      }
    ];
  }

  translateControlTagOptions = (translations) => {
    const { admin, critical, elim, eng_ing, sub, ppe_epp } = translations
    return [
      {
        key: 'Critical',
        value: 'Critical',
        text: critical
      },
      {
        key: 'Eliminate',
        value: 'Eliminate',
        text: elim
      },
      {
        key: 'Substitution',
        value: 'Substitution',
        text: sub
      },
      {
        key: 'Engineering',
        value: 'Engineering',
        text: eng_ing
      },
      {
        key: 'Admin',
        value: 'Admin',
        text: admin
      },
      {
        key: 'PPE',
        value: 'PPE',
        text: ppe_epp
      },
    ]
  }

  translateRiskTagOptions = (translations) => {
    const { human_rights, mer } = translations
    return [
      {
        key: 'Human Rights',
        value: 'Human Rights',
        text: human_rights
      },
      {
        key: 'MER',
        value: 'MER',
        text: mer
      },
    ]
  }

  translateTagOptions = (translations) => {
    return this.translateRiskTagOptions(translations).concat(this.translateControlTagOptions(translations))
  }


  static translateBusinessAreaTagOptions = (translations) => {
    return ['business_area_1', 'business_area_2', 'business_area_3'].map((businessArea) => ({
      key: businessArea,
      value: businessArea,
      text: translations[businessArea] || businessArea
    }))
  }
}



// WEBPACK FOOTER //
// ./src/services/languageService.js